<template>
  <field-frame :field="field" :show-optional="showOptional">
    <div class="flex flex-col gap-2">
      <div
        role="button"
        tabindex="0"
        :aria-label="hasDrawing ? $t('描き直す (領域をクリックまたはタップ)') : $t('描き込む (領域をクリックまたはタップ)')"
        class="figure-trigger group relative bg-white border-2 border-dashed border-q4cl-border rounded-q4cl p-3 text-center cursor-pointer hover:border-q4cl-accent hover:bg-sky-50 focus-visible:outline-none focus-visible:border-q4cl-accent focus-visible:ring-2 focus-visible:ring-q4cl-accent transition-colors"
        @click="openDraw"
        @keydown.enter.prevent="openDraw"
        @keydown.space.prevent="openDraw"
      >
        <!--
          旧旧版踏襲 (Q4CL-client_old_version.xml:443):
          表示は <img :src="field.src || field.baseImgSrc" />。
          実問診票では qstDef で field.src に画像 URL が入る。 baseImgSrc は補助的存在。
        -->
        <img v-if="field.src || field.baseImgSrc"
             :src="field.src || field.baseImgSrc"
             :class="['max-w-full mx-auto', hasDrawing ? '' : 'opacity-60 group-hover:opacity-80 transition-opacity']"
             :alt="hasDrawing ? $t('描き込まれた図') : $t('描画用の背景画像')" />
        <div v-else class="text-q4cl-muted text-sm py-8 flex flex-col items-center gap-2">
          <i class="fa-solid fa-pen-nib text-3xl text-q4cl-border group-hover:text-q4cl-accent transition-colors" aria-hidden="true"></i>
          <span>{{ $t('ここをクリックまたはタップして描き込んでください') }}</span>
        </div>
        <div v-if="field.src || field.baseImgSrc" class="absolute inset-0 bg-q4cl-primary/0 group-hover:bg-q4cl-primary/5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all pointer-events-none">
          <span class="text-xs font-bold text-q4cl-primary bg-white/90 px-3 py-1 rounded-full shadow">
            <i class="fa-solid fa-pen-nib mr-1" aria-hidden="true"></i>{{ hasDrawing ? $t('クリックで描き直す') : $t('クリックで描き込む') }}
          </span>
        </div>
      </div>
      <div v-if="hasDrawing" class="flex justify-end">
        <button type="button" class="btn-secondary !py-1 !px-3 text-xs" @click="clear">
          <i class="fa-solid fa-trash-can mr-1" aria-hidden="true"></i>{{ $t('クリア') }}
        </button>
      </div>
    </div>
    <!--
      旧旧版踏襲 (Q4CL-client_old_version.xml:2498-2501):
      旧旧版は drawImgSrc (field.src) を背景 canvas に焼くだけ、 描画レイヤーは透明のまま。
      base-img だけ渡せば旧版と同等動作 (initial は使わない、 描画レイヤー二重化を避ける)。
    -->
    <modal-draw v-if="open"
                :base-img="field.src || field.baseImgSrc"
                @close="open = false" @save="onSave" />
  </field-frame>
</template>

<script>
import FieldFrame from '@/components/ui/FieldFrame.vue'
import ModalDraw from '@/components/modals/ModalDraw.vue'
export default {
  name: 'FigureField',
  components: {
    'field-frame': FieldFrame,
    'modal-draw': ModalDraw
  },
  props: {
    field: { type: Object, required: true },
    showOptional: { type: Boolean, default: false }
  },
  setup(props) {
    const open = Vue.ref(false);
    // 「描き込み済み」 判定: field.src が data:URL なら描画済み (=dataUrl が入っている)、
    // http/https URL ならまだ素の元画像 (=描画前)
    const hasDrawing = Vue.computed(() => {
      const s = props.field.src || '';
      return s.startsWith('data:');
    });
    function openDraw() { open.value = true; }
    async function onSave(dataUrl) {
      const enc = window.encryption;
      props.field.src = dataUrl;
      props.field.encryptedImgData = await enc.encryptStrWithHash(dataUrl);
      open.value = false;
    }
    function clear() {
      props.field.src = '';
      props.field.encryptedImgData = '';
    }
    return { open, hasDrawing, openDraw, onSave, clear };
  }
};
</script>
